import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { update as updateRubric } from 'js/actions/rubric-actions';
import { LoadingMessage } from 'js/components';
import RubricConfigurationComponent from '../components/RubricConfigurationComponent';

function RubricConfigurationContainer({
  workspaceId,
  rubricId,
  rubric,
  rubricLoadFailed,
  updateRubric,
}) {
  const handleSave = useCallback(
    (payload) => updateRubric(rubricId, payload),
    [updateRubric, rubricId]
  );

  if (!rubric && !rubricLoadFailed) {
    return <LoadingMessage iconSize="2x">Loading rubric…</LoadingMessage>;
  }

  if (!rubric) {
    return null;
  }

  return (
    <RubricConfigurationComponent
      workspaceId={workspaceId}
      rubric={rubric}
      onSave={handleSave}
    />
  );
}

export default connect(null, { updateRubric })(RubricConfigurationContainer);
